// Screenname:DeliveryTerms master
// Developer Name: Jagadish.
// Created date on: 2 / 2 / 2023
// Comments and Suggestions:
// TS File: Service
// Messages: 
import httpbaseURL from '../../common/axios';
class GatePassServices {


    getData(tableId) {
        return httpbaseURL.httpMSInventoryUrl.get(`/Gatepass/Get?id=${tableId}`);
    }

    createdata(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/Gatepass/Create", doc);
    }
    updateData(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/Gatepass/Update", doc);
    }

    listGatePass() {
        return httpbaseURL.httpMSInventoryUrl.get("/Gatepass/List");
    }

    getServiceAutoCompleteList(AsId, HId, BId, SId) {
        return httpbaseURL.httpMSInventoryUrl.get("/AssetService/ServiceAutocompleteList?ServiceVar=" + AsId + "&HospitalId=" + HId + "&BranchId=" + BId + "&StoreId=" + SId)
    }

    closeGatePass(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/Gatepass/CloseGatePass", doc);
    }
}
export default new GatePassServices()